import React, { useState } from 'react';

// reactstrap components
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Badge,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";


// Import new modular components
import MerchantAddressesTab from '../../components/tabs/MerchantAddressesTab';
import MerchantOwnersTab from '../../components/tabs/MerchantOwnersTab';

// Import new BankInformationModalTab
import BankInformationModalTab from '../../components/BankInformationModalTab';
import DocumentUpload from '../../../../components/Documents/DocumentUpload';
import DocumentSearchList from '../../../../components/Documents/DocumentSearchList';
import NotesPanel from '../../../../components/Notes/NotesPanel';

function MerchantDetailsModal({ isOpen, toggle, merchant }) {
  // State for active tab - Always declare hooks at the top level
  const [activeTab, setActiveTab] = useState('1');
  const [showUpload, setShowUpload] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  if (!merchant) {
    return null;
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
  };

  // Function to toggle tabs
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <>
      <style>
      {`
        .compact-table {
          table-layout: fixed;
          width: 100%;
          border-collapse: collapse;
          font-size: 0.875rem;
          line-height: 1.15;
        }
        .compact-table td {
          padding: 2px 6px;
          vertical-align: top;
        }
        .compact-label {
          width: 40%;
          white-space: nowrap;
          font-weight: 600;
          color: #4a5568;
        }
        .compact-value {
          display: block;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap; 
          color: #1a202c;
        }
        .break-anywhere {
          display: block;
          color: #1a202c;
          overflow-wrap: anywhere;  
          word-break: break-word;
          white-space: normal;      
        }
        .truncate-text {
          display: block;             
          max-width: 500px;           
          white-space: nowrap;        
          overflow: hidden;          
          text-overflow: ellipsis;    
        }
      `}
    </style>
    <Modal isOpen={isOpen} toggle={toggle} size="xl" scrollable>
      <ModalHeader toggle={toggle} className="bg-gradient-info text-white">
        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
          <div className="d-flex align-items-center mb-2 mb-md-0">
            <i className="ni ni-shop mr-3" style={{ fontSize: '1.5rem' }}></i>
            <h4 className="mb-0 truncate-text" style={{ fontSize: '1.25rem' }}>
              {merchant.legalName}
            </h4>
          </div>
          <div className="ml-md-3">
            <small className="text-white d-block d-md-inline" style={{ opacity: 0.9, fontSize: '0.875rem' }}>
              Created by: {merchant.createdBy || merchant.created_by || 'System'} | Tax ID: {merchant.federalTaxId}
            </small>
          </div>
        </div>
      </ModalHeader>
      
      <ModalBody className="px-4">
        {/* Navigation Tabs */}
        <Nav tabs className="nav-fill flex-column flex-md-row" id="tabs-icons-text" role="tablist">
          <NavItem>
            <NavLink
              aria-selected={activeTab === '1'}
              className={`mb-sm-3 mb-md-0 ${activeTab === '1' ? 'active' : ''}`}
              onClick={() => toggleTab('1')}
              href="#"
              role="tab"
            >
              <i className="ni ni-shop mr-2"></i>
              General & Addresses
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              aria-selected={activeTab === '2'}
              className={`mb-sm-3 mb-md-0 ${activeTab === '2' ? 'active' : ''}`}
              onClick={() => toggleTab('2')}
              href="#"
              role="tab"
            >
              <i className="ni ni-single-02 mr-2"></i>
              Owners
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              aria-selected={activeTab === '3'}
              className={`mb-sm-3 mb-md-0 ${activeTab === '3' ? 'active' : ''}`}
              onClick={() => toggleTab('3')}
              href="#"
              role="tab"
            >
              <i className="ni ni-money-coins mr-2"></i>
              Bank Information
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              aria-selected={activeTab === '4'}
              className={`mb-sm-3 mb-md-0 ${activeTab === '4' ? 'active' : ''}`}
              onClick={() => toggleTab('4')}
              href="#"
              role="tab"
            >
              <i className="ni ni-archive-2 mr-2"></i>
              Documents
            </NavLink>
          </NavItem>
        </Nav>

        {/* Tab Content */}
        <TabContent activeTab={activeTab}>
        {/* Tab 1: General Information & Addresses */}
               <TabPane tabId="1">
                 <Row>
                   <Col md="12">
                      <Card>
                       <CardHeader style={{ backgroundColor: '#e3f2fd', borderColor: '#bbdefb' }}>
                         <div className="d-flex align-items-center">
                           <i className="ni ni-briefcase-24 text-primary mr-2" />
                           <h5 className="mb-0 text-dark" style={{ fontSize: '1rem' }}>Business Information</h5>
                         </div>
                       </CardHeader>
                       <CardBody>
                         <Row>
                           <Col lg="6" md="12" className="mb-1">
                            <Table borderless className="compact-table">
                              <tbody>
                                <tr>
                                  <td className="compact-label">Legal Name:</td>
                                  <td>
                                    <div className="compact-value">{merchant.legalName || 'N/A'}</div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="compact-label">DBA Name:</td>
                                  <td>
                                    <div className="compact-value">{merchant.dbaName || 'N/A'}</div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="compact-label">Industry:</td>
                                  <td>
                                    <div className="compact-value">{merchant.industry || 'N/A'}</div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="compact-label">Website:</td>
                                  <td>
                                    <div className="break-anywhere">
                                      {merchant.website ? (
                                        <a>                                        
                                          {merchant.website}
                                        </a>
                                      ) : 'N/A'}
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="compact-label">Phone Number:</td>
                                  <td>
                                    <div className="compact-value">{merchant.phoneNumber || 'N/A'}</div>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                           </Col>
                           <Col lg="6" md="12">
                            <Table borderless className="compact-table">
                              <tbody>
                                <tr>
                                  <td className="compact-label">Business Structure:</td>
                                  <td>
                                    <div className="compact-value">{merchant.businessStructure || 'N/A'}</div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="compact-label">Federal Tax ID:</td>
                                  <td>
                                    <div className="compact-value">{merchant.federalTaxId || 'N/A'}</div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="compact-label">State of Formation:</td>
                                  <td>
                                    <div className="compact-value">{merchant.stateOfInc || 'N/A'}</div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="compact-label">Date Established:</td>
                                  <td>
                                    <div className="compact-value">{formatDate(merchant.dateEstablished)}</div>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </Col>
                         </Row>
                       </CardBody>
                     </Card>
                     
                     {/* Addresses Section */}
                     <MerchantAddressesTab merchant={merchant} />
                     
                     {/* Notes Section */}
                     <Card className="shadow-sm mb-4">
                       <CardHeader style={{ backgroundColor: '#e3f2fd', borderColor: '#bbdefb' }}>
                         <div className="d-flex align-items-center">
                           <i className="ni ni-single-copy-04 text-primary mr-2" />
                           <h5 className="mb-0 text-dark" style={{ fontSize: '1rem' }}>Notes</h5>
                         </div>
                       </CardHeader>
                       <CardBody>
                         <NotesPanel
                           tag="merchant-notes"
                           originType="MERCHANT"
                           originId={merchant.id}
                           title="Merchant Notes"
                           onNoteAdded={(note) => console.log('Note added:', note)}
                           onNoteUpdated={(noteId, newMessage) => console.log('Note updated:', noteId, newMessage)}
                           onNoteDeleted={(noteId) => console.log('Note deleted:', noteId)}
                         />
                       </CardBody>
                     </Card>
                   </Col>
                 </Row>
               </TabPane>

          {/* Tab 2: Owners */}
          <TabPane tabId="2">
            <MerchantOwnersTab merchant={merchant} />
          </TabPane>

          {/* Tab 3: Bank Information */}
          <TabPane tabId="3">
            <Row>
              <Col md="12">
            <BankInformationModalTab 
                  merchantId={merchant.id}
              isReadOnly={false}
            />
              </Col>
            </Row>
          </TabPane>

          {/* Tab 4: Documents */}
          <TabPane tabId="4">
            <Row>
              <Col md="12">
                <Card className="shadow-sm">
                  <CardHeader style={{ backgroundColor: '#e3f2fd', borderColor: '#bbdefb' }} className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 text-dark" style={{ fontSize: '1rem' }}>
                      <i className="ni ni-archive-2 mr-2"></i>
                      Documents
                    </h5>
                    <Button color="primary" size="sm" onClick={() => setShowUpload(!showUpload)}>
                      {showUpload ? 'Hide upload' : 'Upload'}
                    </Button>
                  </CardHeader>
                  <CardBody>
                    {showUpload && (
                      <div className="mb-4">
                        <DocumentUpload
                          originId={merchant.id}
                          originType="merchant"
                          category="merchant"
                          onUploaded={() => {
                            setShowUpload(false);
                            // trigger refresh list by toggling key
                            setRefreshKey((k) => k + 1);
                          }}
                        />
                      </div>
                    )}
                    <DocumentSearchList originId={merchant.id} originType="merchant" refreshKey={refreshKey} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </ModalBody>
      
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
    </>
  );
}

export default MerchantDetailsModal;
